export const FIRST_NAME_REGEX = /[^a-zA-Z-. ']/gi;
export const LAST_NAME_REGEX = /[^a-zA-Z-. ']/gi;
export const ADDRESS_REGEX = /[^a-z0-9. '"/#$&,(){}?!@%^&*:;_+=|<>\-[\]\\]/gi;
export const CITY_REGEX = /[^a-zA-Z-. ']/gi;
export const ZIP_CODE_REGEX = /[^0-9-]/gi;
export const EMAIL_REGEX = /[^a-zA-Z0-9._%@+\-']/gi;
export const FREEFORM_REGEX = /[^a-z0-9. '"/#$&,(){}?!@%^&*:;_+=|<>\-[\]\n\t\s\\]/gi;
